import { version } from '@raiz/package.json';

export const environment = {
  production: false,
  urlApiArgon: 'https://argon-api.test.sla03.devtest.aws.scania.com',
  redirectUri: 'https://argon.test.sla03.devtest.aws.scania.com/',
  protectedResource: 'https://argon-api.test.sla03.devtest.aws.scania.com',
  AppVersion : `${version} - Acceptance`,

};

